import { CommunityTab } from '../../interfaces/community-tab.interface';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

const TAB_ANIMATIONS = [
  trigger('tabAnimation', [
    state(
      'active',
      style({
        opacity: 1,
      })
    ),
    state(
      'inactive',
      style({
        opacity: 0.6,
      })
    ),
    transition('inactive => active', [animate('300ms ease-in')]),
    transition('active => inactive', [animate('300ms ease-out')]),
  ]),
];

type CommunityTabsStyle = 'gradient' | 'solid';
@Component({
  selector: 'app-community-tabs',
  templateUrl: './community-tabs.component.html',
  styleUrls: ['./community-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: TAB_ANIMATIONS,
  standalone: true,
})
export class CommunityTabsComponent {
  tabs = input<CommunityTab[]>([]);
  type = input<CommunityTabsStyle>('gradient');

  selectedTab = input.required<CommunityTab>();
  tabSelected = output<CommunityTab>();

  selectTab(tab: CommunityTab): void {
    this.tabSelected.emit(tab);
  }

  getTabState(isActive: boolean): string {
    return isActive ? 'active' : 'inactive';
  }
}
